import { useMediaQuery } from "react-responsive"

const SeparatorLine = () => {

    const isMobile = useMediaQuery({ maxWidth: 1280 })

    if (isMobile)
        return (
            <hr className="separator-line-mobile" />
        )
    else
        return (
            <hr className="separator-line" />
        )


}

export default SeparatorLine